// extracted by mini-css-extract-plugin
export default {"canvas":"SignatureControlled_canvas__-0+BG"};